<template>
  <div id="bars">
    <svg width="100%" height="400"></svg>
  </div>
</template>
<script>
import { Bar } from "vue-chartjs";
import * as d3 from "d3";
import chartModule from "@/services/dcbox.js";

export default {
  name: "StackedBar",
  extends: Bar,
  props: {
    labels: Array,
    dataset: Array
  },
  data() {
    return {
      colors: this.$store.state.chartColors,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    };
  },
  computed: {
    reports: function() {
      return this.$store.state.filteredReports;
    },
    chartSelection: function() {
      return this.$store.state.chartSelection;
    },
    sexualIdentity: function () {
      return this.$store.state.options.sexualIdentity;
    }
  },
  watch: {
    reports: function() {
      this.draw();
    },
    sexualIdentity: function() {
      this.draw();
    }
  },
  methods: {
    draw() {
      const svg = d3.select("#bars svg");
      const width = svg.style("width").replace("px", "");
      const height = +svg.attr("height");
      const config = {
        size: {
          width: width,
          height: height,
          margin: {
            left: 30,
            right: 10,
            top: 10,
            bottom: 70
          }
        },
        xAxis: {
          enabled: true,
          scale: "band",
          ticks: {
            enabled: true
          }
        },
        yAxis: {
          enabled: true,
          scale: "linear",
          ticks: {
            enabled: true,
            style: "dashLine",
            format: function(e){
              if(Math.floor(e) != e)
              {
                  return;
              }

              return e;
            }
          },
          minZero: true
        }
      };

      let dataset = [];

      this.sexualIdentity.forEach(type => {
        //let states = [];
        let size;
        const reports = this.reports.filter(report => {
          return type.trim() === report[this.chartSelection].trim();
        });
        size = reports.length;

        dataset.push({
          [this.chartSelection]: type,
          size: size
        });
      });
      var bars = chartModule
        .config(config)
        .bindTo("#bars svg")
        .data({ raw: dataset })
        .layer("bars")
        .fill(this.chartSelection)
        .colors(this.colors)
        .sortBy(["size"]);

      bars.x(this.chartSelection).y("size");

      chartModule.draw();
    }
  },
  mounted() {
    if (this.sexualIdentity)
      this.draw();
    /* this.$watch(
      vm => [vm.labels, vm.dataset],
      val => {
        this.renderChart(
          {
            labels: this.labels,
            datasets: this.dataset
          },
          this.options
        );
      },
      { immediate: true }
    ); */
  }
};
</script>

<style></style>
